export const navigation = [
  {
    name: 'Dashboard',
    url: 'dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  }
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/_nav.ts